import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { brandAssets } from '../lib/brandAssets';
import { api } from '../lib/api';
import { useOrganisationId } from '../lib/session';
import { useTheme } from '../theme/ThemeProvider';
import { BrandWordmark } from './BrandWordmark';

/**
 * Org switcher lockup — Ghost Screen - Home.dc.html sidebar brand.
 */
export function SidebarBrand() {
  const { t } = useTranslation('layout');
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const organisationId = useOrganisationId();
  const orgsQuery = useQuery({
    queryKey: ['my-organisations'],
    queryFn: api.listMyOrganisations,
  });
  const orgName =
    orgsQuery.data?.find((org) => org.id === organisationId)?.name ?? t('brand.organisationFallback');

  return (
    <div className="shrink-0 px-3.5 pb-2.5 pt-4">
      <Link
        to="/setup"
        className="flex items-center gap-[11px] rounded-xl p-2 no-underline transition-colors hover:bg-[var(--gs-panel2)]"
        style={{ color: 'var(--gs-ink)' }}
        title={t('brand.switchOrganisation')}
      >
        <span
          className="grid h-[38px] w-[38px] shrink-0 place-items-center rounded-[10px] border"
          style={{ background: 'var(--gs-panel2)', borderColor: 'var(--gs-line)' }}
        >
          <img
            src={isDark ? brandAssets.monitorIconOnDark : brandAssets.monitorIconOnLight}
            alt=""
            draggable={false}
            className="h-[26px] w-[26px] object-contain"
          />
        </span>
        <span className="flex min-w-0 flex-1 flex-col gap-0.5">
          <BrandWordmark className="h-8 max-w-full" />
          <span
            className="truncate text-[12.5px] leading-tight"
            style={{ color: 'var(--gs-muted)' }}
          >
            {orgName}
          </span>
        </span>
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="shrink-0"
          style={{ color: 'var(--gs-muted)' }}
          aria-hidden
        >
          <path d="m7 15 5 5 5-5" />
          <path d="m7 9 5-5 5 5" />
        </svg>
      </Link>
    </div>
  );
}
